var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('section', {
    staticClass: "section"
  }, [_c('v-container', [_c('company-view-card', _vm._b({}, 'company-view-card', {
    company: _vm.company
  }, false))], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }